// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_33d92c76","iconWrapper":"_4a2589dd"};